module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('TableView', {
    attrs: {
      "registerName": "Inserir Laboratório",
      "onRegister": (this.validarPermissao(570) ? _vm.onRegister : null),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLaboratorio,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingEditAll,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d680922"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/laboratorio/index.vue
// module id = 1527
// module chunks = 45